import { render, staticRenderFns } from "./DocumentDate.vue?vue&type=template&id=3db9cf80&"
import script from "./DocumentDate.vue?vue&type=script&lang=ts&"
export * from "./DocumentDate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports